module.exports = __webpack_public_path__ + "assets/0e4ea84f76eb74d6235578ad149b2194.svg";